import { render } from "./shopping-detail.vue?vue&type=template&id=46ad97db"
import script from "./shopping-detail.vue?vue&type=script&lang=js"
export * from "./shopping-detail.vue?vue&type=script&lang=js"

import "./shopping-detail.vue?vue&type=style&index=0&id=46ad97db&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__